export default {
	dueDate: 'Tähtaeg | Tähtajani',
	day: 'päev | päeva',
	overdue: 'Aegunud',
	today: 'Täna',
	now: 'Nüüd',
	onTime: 'Graafikus',
	approaching: 'Lähenemas',
	critical: 'Kriitiline',
	date: 'Kuupäev',
}
